import { NetworkStatus } from '@cbridge-utils/network';
import type { IExposureProfileStore } from './exposure.interface';

export const POLLING_INTERVAL = 5000;

export const exposureInitialState: IExposureProfileStore = {
  symbols: {
    data: [],
    networkStatus: NetworkStatus.None,
  },
  details: {
    data: undefined,
    networkStatus: NetworkStatus.None,
  },

  lastUpdated: 0,
};
